export const PAYMENT_SETUP_ACTIONS = {
  HYDRATE: 'HYDRATE',
  SET_LETTER_TYPE: 'SET_LETTER_TYPE',
  PATCH_ASSURANCE: 'PATCH_ASSURANCE',
  TOGGLE_METHOD_CHANNEL: 'TOGGLE_METHOD_CHANNEL',
  UPDATE_METHOD_CONFIG: 'UPDATE_METHOD_CONFIG',
  SET_PHASES: 'SET_PHASES'
};

export const paymentSetupReducer = (state, action) => {
  switch (action.type) {
    case PAYMENT_SETUP_ACTIONS.HYDRATE:
      return action.payload;

    case PAYMENT_SETUP_ACTIONS.SET_LETTER_TYPE:
      return { ...state, letter_type: action.payload };

    case PAYMENT_SETUP_ACTIONS.PATCH_ASSURANCE:
      return {
        ...state,
        assurance_thresholds: { ...state.assurance_thresholds, ...action.payload }
      };

    case PAYMENT_SETUP_ACTIONS.TOGGLE_METHOD_CHANNEL: {
      const { field, channel, enabled } = action.payload;
      return {
        ...state,
        payment_methods: state.payment_methods.map((m) =>
          m.field === field ? { ...m, [channel]: enabled } : m
        )
      };
    }

    case PAYMENT_SETUP_ACTIONS.UPDATE_METHOD_CONFIG: {
      const { field, config } = action.payload;
      return {
        ...state,
        payment_methods: state.payment_methods.map((m) =>
          m.field === field ? { ...m, config } : m
        )
      };
    }

    case PAYMENT_SETUP_ACTIONS.SET_PHASES:
      return { ...state, phases: action.payload };

    default:
      return state;
  }
};

export const hydrateAction = (payload) => ({
  type: PAYMENT_SETUP_ACTIONS.HYDRATE,
  payload
});

export const setLetterTypeAction = (value) => ({
  type: PAYMENT_SETUP_ACTIONS.SET_LETTER_TYPE,
  payload: value
});

export const patchAssuranceAction = (patch) => ({
  type: PAYMENT_SETUP_ACTIONS.PATCH_ASSURANCE,
  payload: patch
});

export const toggleMethodChannelAction = (field, channel, enabled) => ({
  type: PAYMENT_SETUP_ACTIONS.TOGGLE_METHOD_CHANNEL,
  payload: { field, channel, enabled }
});

export const updateMethodConfigAction = (field, config) => ({
  type: PAYMENT_SETUP_ACTIONS.UPDATE_METHOD_CONFIG,
  payload: { field, config }
});

export const setPhasesAction = (phases) => ({
  type: PAYMENT_SETUP_ACTIONS.SET_PHASES,
  payload: phases
});
